var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIctSelectIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_371)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.3088 5.76206H8.73253V2.84063C8.73253 1.80847 7.89281 0.96875 6.86065 0.96875C6.35862 0.96875 5.88662 1.16547 5.53168 1.52269C5.17887 1.87772 4.98609 2.34644 4.98875 2.84266V6.89191H3.6914C2.8285 6.89191 2.12646 7.59394 2.12646 8.45684V10.1576C2.12643 13.3963 4.76134 16.0312 8.00009 16.0312C11.2388 16.0312 13.8737 13.3963 13.8737 10.1576V7.327C13.8737 6.46409 13.1717 5.76206 12.3088 5.76206ZM12.8737 10.1576C12.8737 12.8449 10.6874 15.0312 8.00009 15.0312C5.31275 15.0312 3.12643 12.8449 3.12643 10.1576V8.45684C3.12643 8.14534 3.37984 7.89191 3.69137 7.89191H4.98871V9.86453C4.98871 10.1407 5.21256 10.3645 5.48871 10.3645C5.76487 10.3645 5.98871 10.1407 5.98871 9.86453V7.39191V2.84131C5.98871 2.84025 5.98871 2.83922 5.98871 2.83816C5.98725 2.60956 6.07684 2.39272 6.24096 2.22756C6.40681 2.06066 6.6269 1.96875 6.86062 1.96875C7.3414 1.96875 7.7325 2.35988 7.7325 2.84063V6.26206C7.7325 6.53819 7.95634 6.76206 8.2325 6.76206H12.3088C12.6203 6.76206 12.8737 7.01547 12.8737 7.327V10.1576H12.8737Z",
    fill: "#505258"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_371"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIctSelectIcon);
export default __webpack_public_path__ + "static/media/ictSelectIcon.43b5ebc4b9ef97dc99bcb216c43abb01.svg";
export { ForwardRef as ReactComponent };